import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Suspense, lazy, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";


import ScrollToTop from "./components/misc/scrollTop";

// Vistas
import View404 from "./views/misc/404";
import LoadView from "./views/misc/load";
import Home from "./views/home";
import QuickView from "./views/quickView";

// Portafolio
const ElSabor = lazy(() => import("./portfolio/landing-page-restaurant"));
const Index = lazy(() => import("./portfolio/landing-page-/index"));
const Portfolio = lazy(() => import("./views/portfolio"));
const Customers = lazy(() => import("./views/customers"));

// Suscripciones
const HOST01 = lazy(() => import("./views/suscripciones/HOST01"));



const pageVariants = require("./animation/pages").pageVariants;

function AnimatedRoutes({ isMexico }) {
  const location = useLocation();

  return (
    <Suspense fallback={<LoadView />} >
      <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="*"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <View404 />
            </motion.div>
          }
        />
        <Route
          path="/"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Home isMexico={isMexico} />
            </motion.div>
          }
        />
        <Route
          path="/desarrollo-web-guadalajara"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Home isMexico={isMexico} />
            </motion.div>
          }
        />
        <Route
          path="/inicio"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <QuickView />
            </motion.div>
          }
        />
        <Route
          path="/portafolio"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Portfolio isMexico={isMexico} />
            </motion.div>
          }
        />
        <Route
          path="/clientes"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Customers />
            </motion.div>
          }
        />

        {/* region Portafolio */}

        <Route
          path="/portafolio/ElSabor"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <ElSabor />
            </motion.div>
          }
          />
          
        <Route
          path="/portafolio/Clinica"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <Index />
            </motion.div>
          }
        />

        {/* region Suscripciones */}

        <Route
          path="/HOST01"
          element={
            <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
              <HOST01 />
            </motion.div>
          }
          />
      </Routes>
    </AnimatePresence>
    </Suspense>
    
  );
}

function App() {
  const [isMexico, setIsMexico] = useState(true);

  useEffect(() => {
    fetch("https://ipwho.is/")
      .then((response) => response.json())
      .then((data) => {
        setIsMexico(data.country_code === "MX");
      })
      .catch((error) => {
        console.error("Error detectando la ubicación:", error);
      });
  }, []);

  return (
    <Router>
      <Toaster position="bottom-left" />
      <ScrollToTop />
      <AnimatedRoutes isMexico={isMexico} />
    </Router>
  );
}

export default App;
